import { liteClient as algoliasearch } from "algoliasearch/lite";
import config from "./config.json";
import { db } from "../firebase";
import { collection, query, getDocs } from "firebase/firestore";

const env = process.env.REACT_APP_ENV;

const customSearchClient = {
  search: async (queries) => {
    if (!queries || !Array.isArray(queries)) {
      throw new Error("Invalid queries format");
    }

    const results = await Promise.all(
      queries.map(async (queryItem) => {
        const { indexName, params } = queryItem;
        const { query: searchQuery, hitsPerPage = 10 } = params;

        const collectionRef = collection(db, indexName);

        let q = query(collectionRef);
        try {
          const querySnapshot = await getDocs(q);

          const hits = querySnapshot.docs
            .map((doc) => ({
              objectID: doc.id,
              ...doc.data(),
              _highlightResult: {
                fullName: {
                  value: doc.data().fullName,
                  matchLevel: "full",
                  matchedWords: [],
                },
                email: {
                  value: doc.data().email,
                  matchLevel: "full",
                  matchedWords: [],
                },
              },
            }))
            .filter((hit) => {
              // Ensure fullName exists and perform a case-insensitive search
              return (
                hit.fullName &&
                hit.fullName.toLowerCase().includes(searchQuery.toLowerCase())
              );
            });

          return {
            hits,
            nbHits: hits.length,
            page: 0,
            nbPages: Math.ceil(hits.length / hitsPerPage),
            hitsPerPage,
            processingTimeMS: 1,
          };
        } catch (error) {
          console.error("Error fetching Firestore data:", error);
          return {
            hits: [],
            nbHits: 0,
            page: 0,
            nbPages: 0,
            hitsPerPage,
            processingTimeMS: 1,
          };
        }
      })
    );

    return { results };
  },
};

export const searchClient =
  env === "localhost"
    ? customSearchClient
    : algoliasearch(config[env].id, config[env].token);

export default searchClient;
